import React, { forwardRef } from 'react'
import componentStyle from './DropTarget.module.scss'


const DropTarget = forwardRef((props, ref) => {

    const {style, className, data, children} = props

    const convertToStyles = data.aS.split(' ').reduce((prev, curr, i, arr) => {
        //console.log('curr = ',curr, componentStyle[curr])
        const returnVar = curr ? (componentStyle[curr] || curr) : ''
        return `${prev}${returnVar!=='' ? ' '+returnVar:''}`
    }, '')
    
    //console.log('DropTarget: ', data.aS.split(' '),'convertToStyles', convertToStyles,'className', className, className === undefined, className === 'undefined ', className?'true':'false')
    return (
        <div ref={ref} data-handler-id={props.dnd_id} className={`${componentStyle.zone}${className ? ' '+className :''}${convertToStyles!=='' ? ' '+convertToStyles : ''}`}>
            <div>{data.label}</div>
            {children}
        </div>)
})

export default DropTarget